import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box, CircularProgress, Alert, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import apiClient from '../../config/axios';
import UserDetailsInfo from './UserDetailsInfo';
import UserDetailsFiles from './UserDetailsFiles';
import UserDetailsCourses from './UserDetailsCourses';
import UserDetailsMemberships from './UserDetailsMemberships';

const UserDetailsPage = () => {
  const { userId } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [files, setFiles] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  // const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUserDetails = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      // Fetch user details
      const foundUser = await apiClient.get(`/api/user/${userId}`);
      if (!foundUser.data) {
        setError('Utente non trovato');
        return;
      }

      setUser(foundUser.data);
      setEnrollments(foundUser.data.enrollments || []);

      // Fetch user payments
      // try {
      //   const paymentsRes = await apiClient.get(`/api/payments/by-user/${userId}`);
      //   setPayments(paymentsRes.data || []);
      // } catch (err) {
      //   console.error('Error loading payments:', err);
      //   setPayments([]);
      // }

      // Fetch user files
      try {
        const filesRes = await apiClient.get(`/api/files/user/${userId}`);
        setFiles(filesRes.data.data || []);
      } catch (err) {
        console.error('Error loading files:', err);
        setFiles([]);
      }
    } catch (err) {
      console.error('Error loading user details:', err);
      setError('Errore nel caricamento dei dettagli utente');
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  if (loading) {
    return (
      <Container maxWidth='xl' sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
          Torna indietro
        </Button>
        <Alert severity='error' sx={{ mb: 2 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
        <Alert severity='warning' sx={{ mb: 2 }}>
          Utente non trovato
        </Alert>
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
          Torna indietro
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth='md' sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <UserDetailsInfo user={user} />
        <UserDetailsMemberships memberships={user.memberships || []} />
        <UserDetailsCourses enrollments={enrollments} userId={userId} />
        <UserDetailsFiles user={user} files={files} />
      </Box>
    </Container>
  );
};

export default UserDetailsPage;
